<template>
  <transition name="modal">
    <div class="modal" tabindex="-1" v-if="service">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <button type="button" class="close position-absolute" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="service-detail">
            <div class="service-image" :style="{ backgroundImage: `url(${service.image})` }"></div>
            <div class="service-content p-4">
              <h3 class="mb-3">{{ service.title }}</h3>
              <div class="service-details" v-html="formattedDescription"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop" @click="$emit('close')"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ServiceDetailModal',
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedDescription() {
      return this.service.detailedDescription.replace(/\n/g, '<br>')
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-dialog {
  max-width: 600px;
  width: 100%;
  margin: 1.75rem;
  position: relative;
  pointer-events: auto;
}

.modal-content {
  position: relative;
  width: 100%;
  border: none;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: -1;
}

.close {
  right: 1rem;
  top: 1rem;
  z-index: 1050;
  color: white;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.close:hover {
  opacity: 1;
}

.service-image {
  height: 200px;
  background-size: cover;
  background-position: center;
}

.service-content {
  background: white;
  max-height: calc(80vh - 200px);
  overflow-y: auto;
}

.service-details {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #444;
}

.service-details ul {
  padding-left: 1.2rem;
  margin-bottom: 0.5rem;
}

.service-details li {
  margin-bottom: 0.3rem;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 1rem;
  }
  
  .service-image {
    height: 150px;
  }
}

/* 删除所有其他动画相关样式，只保留以下代码 */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-dialog,
.modal-leave-to .modal-dialog {
  transform: translateY(-80px);
}

.modal-enter-to .modal-dialog,
.modal-leave-from .modal-dialog {
  transform: translateY(0);
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}

.modal-enter .modal-dialog, .modal-leave-to .modal-dialog {
  transform: translateY(-0px);
}

</style>
